<template>
	<div class="container">
		<div class="main">
			<div class="title-box-login">
				<span class="title">百草创新BI大模型应用系统</span>
			</div>
			<div class="login-box">
				<div>
					<div class="edit-main">
						<div class="itemTitle">账号</div>
						<div class="edit-box">
							<img src="../assets/zh.png" style="width: 14px;height: 16px;" />
							<input class="input" v-model="name" placeholder="请输入账号" autocomplete="new-password">
						</div>
						<div class="itemTitle">密码</div>
						<div class="edit-box">
							<img src="../assets/mm.png" style="width: 14px;height: 16px;" />
							<input class="input" v-model="password" type="password" placeholder="请输入密码"
								autocomplete="new-password">
						</div>
						<div class="itemTitle">验证码</div>
						<div class="verify-box">
							<div class="edit-box1">
								<img src="../assets/yzm.png" style="width: 14px;height: 16px;" />
								<input class="input" v-model="inputCode" style="width: 0" placeholder="请输入验证码"
									maxlength="4">
							</div>
							<img class="img-verify" arc="code" id="code" @click="event().onVerifyImgClicked()">
						</div>
						<div class="flex flex-b" style="margin-top: 30px;">
							<el-checkbox v-model="checked">记住密码</el-checkbox>
							<div class="flex" @click="forgetShow=true" style="color: #3B82F6;cursor: pointer;">忘记密码？
							</div>
						</div>
						<el-button class="login-btn" @click="event().onLogin()">登录
						</el-button>
					</div>
				</div>
			</div>
		</div>
		
		<el-dialog
		  title=""
		  :visible.sync="forgetShow"
		  width="20%"
		  >
		  <div class="forshowbg">
			  <div class="ysbg">
				  <img src="../assets/ys.png" style="width: 40px;height: 40px;"/>
			  </div>
			  <div class="tit">忘记密码？</div>
			  <div class="des">请联系管理员重置密码</div>
			  <div class="btns" @click="forgetShow = false">
				  <div class="te">我知道了</div>
				  <i class="el-icon-right" style="margin-left: 5px;"></i>
			  </div>
		  </div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		encrypt
	} from "@/filters/filter";
	import {
		login,
		menulist,
		getCaptcha
	} from "@/api/common";
	import {
		pms2MenuList
	} from "../filters/filter";
	import Utils from "@/jslibs/utils";
	import {
		mapMutations,
		mapActions
	} from "vuex";
	// import { LimitsList } from '@/api/auth'

	export default {
		data() {
			return {
				forgetShow: false,
				checked: false,
				code: "",
				inputCode: "",
				name: "",
				password: "",
				rules: [],
				permissionList: [],
				operationList: [{
					name: "样例管理",
					operations: ["编辑", "删除", "导出"]
				}],
				menuList: [],
				noChildMunuList: ["酒店商品管理"] //mixin operation 记得也要改
			};
		},

		created() {},

		mounted() {
			let loginAccount = localStorage.getItem('loginAccount')
			let loginPassword = localStorage.getItem('loginPassword')
			if (loginAccount && loginPassword) {
				this.name = loginAccount
				this.password = loginPassword
				this.checked = true
			}
			this.handler().refreshCode();
		},
		methods: {
			...mapMutations([
				"update_operation_list",
				"update_permission_list",
				"updateLoginData"
			]),
			...mapActions(["getCommonInfo"]),
			event() {
				const self = this;
				return {
					onVerifyImgClicked() {
						self.handler().refreshCode();
					},
					onLogin: () => {
						this.network().addlogin();
						// this.$router.push({
						// 	path: '/user-list'
						// })
					}
				};
			},
			network() {
				return {
					/*  getListA() {}, */
					addlogin: async () => {
						if (!this.handler().verifyInput()) return;
						const {
							status,
							data
						} = await login({
							account: this.name,
							password: this.password,
							code: this.inputCode,
							code_key: this.code
						});
						if (status !== 200) {
							this.handler().refreshCode()
							return;
						}
						if (this.checked) {
							localStorage.setItem('loginAccount', this.name)
							localStorage.setItem('loginPassword', this.password)
						}
						Utils.setCookie("authorization", data.result.token, 7); // TODO: 先设三天过期
						Utils.setCookie("adminName", data.result.name, 7); // TODO: 先设三天过期  */
						this.$router.push("/user-list");
						// this.handler().buildTree(data.result.group.rule);
					},
					getAdminAuthMenu: async () => {
						let postData = {
							page_size: 1000,
							page_index: 1,
							type: 1
						};
						const {
							status,
							data
						} = await menulist(postData);
						if (status !== 200) return;
						this.handler().buildTree(data.result.data);

					}
				};
			},

			handler() {
				const self = this;
				return {
					async refreshCode() {
						// eslint-disable-next-line no-undef
						const res = await getCaptcha();
						const img = document.getElementById("code");
						img.src = res.data.result.img;
						self.code = res.data.result.key;
					},
					verifyInput: () => {
						if (!this.name || !this.name.trim()) {
							this.$message({
								message: "请输入账号",
								type: "warning"
							});
							return false;
						}
						if (!this.password || !this.password.trim()) {
							this.$message({
								message: "请输入密码",
								type: "warning"
							});
							return false;
						}
						if (!this.inputCode || !this.inputCode.trim()) {
							this.$message({
								message: "请输入验证码",
								type: "warning"
							});
							return false;
						}
						// if (this.code.toLowerCase() !== this.inputCode.toLowerCase()) {
						// 	this.$message({
						// 		message: "验证码错误",
						// 		type: "warning"
						// 	});
						// 	this.refreshCode();
						// 	return false;
						// }
						return true;
					},
					buildTree: tree => {
						this.permissionList = [];
						this.operationList = [];
						var permissionList = [];
						tree.forEach(item => {
							var permissionItem = {};
							permissionItem.name = item.menu_name;
							permissionItem.uuid = item.id;
							permissionItem.url = item.menu_url;
							var childrenList = [];
							if (item.son_rule && item.son_rule.length) {
								item.son_rule.forEach(two => {
									if (two.type != "3") {
										var permissiontwo = {};
										permissiontwo.name = two.menu_name;
										permissiontwo.uuid = two.id;
										permissiontwo.url = two.menu_url;
										childrenList.push(permissiontwo);
									} else {
										this.operationList.push(two);
									}

								})
							}
							permissionItem.children = childrenList;
							permissionList.push(permissionItem);
						})
						const jsonStrPer = JSON.stringify(permissionList);
						// // 对权限列表进行加密
						const encryptPer = encrypt(jsonStrPer).toString();
						sessionStorage.setItem("permission", jsonStrPer);
						// 存储有权限列表和操作列表到store
						this.update_permission_list(encryptPer);
						this.update_operation_list(this.operationList);
						//let menuList = pms2MenuList(this.permissionList);
						this.$router.push("/");
					}
				};
			}
		},
		watch: {},
		computed: {}
	};
</script>

<style scoped lang="less">
	.title-box-login {
		width: 100%;
		text-align: center;
		margin-bottom: 84px;

		.title {
			font-family: Roboto, Roboto;
			font-weight: 500;
			font-size: 36px;
			color: #000000;
		}
	}

	.container {
		display: flex;
		flex-direction: column;
		width: 100%;
		height: 100vh;

		.main {
			flex: 1;
			background-color: #F9FAFB;
			background-size: cover;
			display: flex;
			justify-content: center;
			align-items: center;
			flex-direction: column;

			.login-box {
				display: flex;
				width: 460px;
				height: 518px;
				background: #FFFFFF rgba(0, 0, 0, 0.001);
				box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1), 0px 4px 6px -4px rgba(0, 0, 0, 0.1);
				border-radius: 8px 8px 8px 8px;
				padding: 32px;

				.img-wrap {
					width: 380px;
					height: 400px;

					img {
						width: 100%;
						height: 100%;
					}
				}

				.edit-main {
					.itemTitle {
						margin-bottom: 8px;
						font-family: Roboto, Roboto;
						font-weight: 400;
						font-size: 16px;
						color: #4B5563;
					}

					.edit-box {
						display: flex;
						align-items: center;
						margin-bottom: 24px;
						width: 396px;
						height: 50px;
						border: 1px solid #eaeaea;
						border-radius: 10px;
						padding: 17px 16px;

						.input {
							padding: 0 14px;
							flex: 1;
							outline: none;
							border: none;
							font-size: 16px;
							background: transparent;
						}
					}

					.verify-box {
						position: relative;
						width: 396px;
						display: flex;
						align-items: center;

						.edit-box1 {
							display: flex;
							align-items: center;
							width: 260px;
							border: 1px solid #eaeaea;
							border-radius: 10px;
							padding: 17px 16px;

							.input {
								padding: 0 14px;
								flex: 1;
								outline: none;
								border: none;
								font-size: 16px;
								background: transparent;
							}
						}

						img#code.img-verify {
							float: left;
							width: 100px;
							height: 40px;
							margin-left: 20px;
						}
					}

					.login-btn {
						width: 396px;
						height: 48px;
						background: #3B82F6;
						border-radius: 4px 4px 4px 4px;
						display: flex;
						align-items: center;
						justify-content: center;
						font-family: Roboto, Roboto;
						font-weight: 400;
						font-size: 16px;
						color: #FFFFFF;
						margin-top: 50px;
					}
				}
			}
		}

		.foot {
			height: 54px;
			display: flex;
			padding: 27px 0 33px;
			font-size: 14px;
			flex-direction: column;
			align-items: center;

			p:first-child {
				margin: 0;
			}

			p:last-child {
				margin-top: 12px;
			}
		}
	}

	/deep/input:-internal-autofill-selected {
		background-color: none !important;
	}
	
	.forshowbg{
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
	}
	.ysbg{
		background-color: rgba(64, 158, 255, 0.2);
		width: 80px;
		height: 80px;
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.tit{
		margin-top: 20px;
		font-size: 18px;
		color: #000;
		font-weight: bold;
	}
	.des{
		margin-top: 10px;
		font-size: 14px;
		color: #999;
	}
	.btns{
		display: flex;
		cursor: pointer;
		align-items: center;
		justify-content: center;
		width: 100%;
		height: 40px;
		background-color: #409eff;
		border-radius: 5px;
		font-size: 14px;
		color: #fff;
		margin-top: 30px;
	}
</style>